<template>
  <div class="card-video">
    <div class="video-player">
      <div :id="`id-${videoID}`"></div>
    </div>

    <div class="video-title">
      {{ video.title }}
    </div>

    <div class="video-metadata">
      <v-chip outlined>
        <v-icon left>date_range</v-icon>
        {{ displayDate(video.date) }}
      </v-chip>

      <v-chip outlined>
        <v-icon left>access_time</v-icon>
        {{ displayTime(video.date) }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { dateFormat, timeFormat } from '@/utils/date';

export default {
  name: 'GloboplayVideoPlayer',
  props: {
    video: Object,
    videoID: Number,
  },
  data() {
    return {
      video_width: '324px',
      video_height: '180px',
    };
  },
  head: {
    link: [{ rel: 'preconnect', href: 'https://horizon-schemas.globo.com' }],
  },
  mounted() {
    this.loadVideo();
  },
  methods: {
    loadVideo() {
      const element = document.getElementById(`id-${this.videoID}`);
      // eslint-disable-next-line no-undef
      const player = new WM.Player({
        videosIDs: this.video.video_id,
        width: this.video_width,
        height: this.video_height,
        skipDFP: true,
      });
      player.attachTo(element);
    },
    displayDate(date) {
      return date ? dateFormat(date) : '---';
    },
    displayTime(date) {
      return date ? timeFormat(date) : '---';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/content-panel.scss';
</style>
